import './LoadingSpinner.css'

const LoadingSpinner = () => {
  return (
    // <div className="lds-facebook">
    //   <div></div>
    //   <div></div>
    //   <div></div>
    // </div>
    <img alt="Loading..." width={128} height={128} className="loadingAnimation" />
  );
};

export default LoadingSpinner;
